
/* injects from baggage-loader */

'use strict';

import AccountDocumentRequestsController from './account.document-requests.controller';
import AccountDocumentRequestsTemplate from './account.document-requests.html';

export default class AccountDocumentRequestsComponent {
	constructor() {
		this.templateUrl = AccountDocumentRequestsTemplate;
		this.controller = AccountDocumentRequestsController;
		this.controllerAs = 'ctrl';
		// Bind resolved items to the controller, see module state for resolve
		this.bindings = {
			documentRequests: '<',
			collectionSize: '<',
			productList: '<',
			documents: '<'
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/document-requests/account.document-requests.component.js